import { useState, useEffect, useRef } from 'react';
import Search from '../../assets/search.png';
import Searchbar from '../../components/Search';
import Report from '../../assets/report_action.png'
import Block from '../../assets/Block123.png'
import { Link, useLocation, useParams } from 'react-router-dom';
import Arrow from '../../assets/Showing_Arrow.png'
import formatTime from '../../components/formatTime'
import formatDate from '../../components/formatDate';
import BlockUser from '../UserList/BlockUser';
import Loader from '../../assets/Loader.gif'
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie'
import { useSelector } from 'react-redux';
import NoData from '../../assets/NoData.png'
import { useGetReportsQuery } from '../../store/api/Reports'
import { useDebounce } from '../../utils/hooks/debounce';
import formatToTitleCase from '../../utils/formatToTitlecase';
import UserProfile from '../../components/UserProfile';

function ReportList() {
  // Sample data for posts
  const [activePage, setActivePage] = useState(1)
  const [selectedValue, setSelectedValue] = useState("10");
  const [userId, setUserId] = useState("")
  const [search, setSearch] = useState("")
  const [Status, setStatus] = useState()
  const navigate = useNavigate()


  const debouncedSearch = useDebounce(search);
  useEffect(() => {
    setActivePage(1);
  }, [debouncedSearch])
  const { data: reportResponse, isFetching, refetch } = useGetReportsQuery({
    page: selectedValue != 10 ? 1 : activePage,
    limit: selectedValue,
    search: debouncedSearch,
    type: 'users'
  });


  const pagination = reportResponse?.data?.pagination;
  const lastPage = pagination?.last_page || 1;
  const currentPage = pagination?.current_page
  const reportList = reportResponse?.data?.reports || [];

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [Username, setUsername] = useState("")
  const dropdownRef = useRef(null);


  // Options for dropdown
  const options = ["10", "25", "50", "100"];

  // Function to handle option selection
  const handleSelect = (value) => {
    setSelectedValue(value);
    setIsDropdownOpen(false);
    setActivePage(1)
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [block, setBlock] = useState(false)
  const [BlockUserId, setBlockUserId] = useState("")
  const handleBlock = (Username, UserId, Status) => {
    setBlock(true)
    setUsername(Username)
    setBlockUserId(UserId)
    setStatus(Status)
  }
  const handleCloseBlock = () => {
    setBlock(false)
  }


  // To open USER PROFILE 
  const { source } = useParams()
  const location = useLocation()
  const handleOpenUserProfile = (userId) => {
    const currentPath = location.pathname.split("/")[1]; // gets 'reel-list', 'user-list', etc.
    setUserId(userId);
    Cookies.set("userId", userId);
    navigate(`/${currentPath}/user-profile`);
  };


  const isSidebarOpen = useSelector((state) => state.sidebar.isOpen);


  return (
    <>
      {/* <div className="mb-10 xl:pl-72"> */}
      <div className={` dark:bg-primary ${isSidebarOpen ? "xl:pl-20" : "xl:pl-72"}`}>
        <Searchbar />

        <div className='px-4 pb-10 xl:px-6'>

          {/* Title */}
          <div className="flex justify-between border-t-[#F2F2F2] pt-3">
            <h2 className="text-[#000000] dark:text-darkText my-auto font-poppins sm:text-xl text-sm font-semibold">User Report List</h2>
            <div className="relative">
              <div className="absolute flex items-center p-2 transform -translate-y-1/2 left-2 top-1/2">
                <img src={Search} alt="Search" className="w-5 h-5" />
              </div>
              <input
                type="text"
                className="border border-gray-500 dark:text-darkText xl:placeholder:text-sm bg-[#00000005] placeholder:dark:text-tableDarkLarge md:w-[250px] w-[180px] border-opacity-10 rounded-lg py-2 pl-10 placeholder:text-xs placeholder:text-[#0000004F] focus:outline-none focus:ring-1 focus:ring-gray-600"
                placeholder="Search by reported username..."
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>

          {/* Navigation Path */}
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <Link to="/dashboard"><h3 className="text-[#3A3A3A] dark:text-darkText font-poppins text-base font-semibold">Dashboard</h3></Link>
              <div className="rounded-full w-1 h-1 bg-[#E0E0E0]"></div>
              <h3 className="text-[#858585] font-poppins text-base">Report List</h3>
            </div>
          </div>

          {/* Header Bar */}
          <div className="border border-[#E3E3E3] dark:border-[#1F1F1F] rounded-lg mt-4 overflow-x-auto w-full">
            <div className='xl:overflow-x-auto lg:overflow-x-auto 2xl:overflow-hidden'>
              <div className='min-w-max'>
                {/* Table Header */}
                <div className="flex justify-between gap-2 px-4 py-3 pl-4 text-left border-b dark:border-b-[#1F1F1F] dark:bg-darkHeader bg-header1 sm:pl-4">

                  {/* SL */}
                  <div className="min-w-[30px] text-headerText font-poppins text-sm font-semibold">S.L </div>

                  {/* Date/Time  */}
                  <div className="min-w-[150px] text-headerText font-poppins text-sm flex place-items-center gap-2 font-semibold">CREATED DATE/TIME
                  </div>

                  {/* Username */}
                  <div className="min-w-[250px] font-semibold text-headerText font-poppins text-sm flex place-items-center gap-2">REPORTED USER NAME
                  </div>

                  {/* Reason */}
                  <div className="min-w-[100px] font-semibold text-headerText font-poppins text-sm flex place-items-center gap-2">REASON</div>
                  {/* Report by */}
                  <div className="min-w-[250px] font-semibold text-headerText font-poppins text-sm flex place-items-center gap-2">REPORTED BY
                  </div>
                  {/* Account status */}
                  <div className="min-w-[130px] font-semibold text-headerText font-poppins text-sm flex place-items-center gap-2">ACCOUNT STATUS
                    {/* <div className='flex flex-col'><button><img src={Dropdown} className='w-2 h-2 rotate-180'/></button><button><img src={Dropdown} className='w-2 h-2'/></button></div> */}
                  </div>
                  {/* Actions */}
                  <div className="min-w-[65px] font-semibold text-center text-headerText font-poppins text-sm">ACTIONS </div>
                </div>

                {/* =================== Data Rows ===================*/}
                {isFetching ? (<div className='flex justify-center py-60'><img src={Loader} alt="loader" height={50} width={50} /></div>) :
                  (<>

                    {reportList?.length > 0 ?

                      (<>
                        {reportList.map((report, index) => (
                          <div key={report.id}
                            className={`${index % 2 === 0 ? 'bg-white dark:bg-primary' : 'bg-[#00162e0a] dark:bg-primary'} dark:border-b-[#1F1F1F] flex items-center justify-between gap-2 px-4 py-3 sm:pl-4 pl-4 border-b last:border-0`}>

                            {/* Serial Number */}
                            <div className="min-w-[30px] text-[#000000] font-poppins text-sm dark:text-darkText">{(currentPage - 1) * selectedValue + index + 1}</div>

                            {/* user id */}
                            <div className="min-w-[150px]">
                              <h2 className="text-[#00162e] font-poppins dark:text-darkText text-sm">{formatDate(report.created_at)}</h2>
                              <h2 className="text-[#7A7A7A] dark:text-tableDarkLarge text-tableLightLarge font-poppins text-xs">{formatTime(report.created_at)}</h2>
                            </div>

                            {/* Reported username */}
                            <div className="min-w-[250px] flex gap-2 items-center">
                              <img src={report.reported_target.photo_url} className="w-12 h-12 rounded-full object-cover" />
                              <div>
                                <h2 title={report.reported_target.stage_name} className="max-25 text-[#000000] dark:text-darkText font-poppins text-sm font-semibold cursor-pointer" onClick={() => handleOpenUserProfile(report.user_id)}>{report.reported_target.stage_name}</h2>
                                <p title={report.reported_target.email} className="max-25 text-xs dark:text-tableDarkLarge text-tableLightLarge font-poppins">{report.reported_target.email}</p>
                              </div>
                            </div>

                            {/* Reason */}
                            <div className="min-w-[100px] text-[#000000] font-semibold font-poppins text-sm">{formatToTitleCase(report.reason)}</div>

                            {/* Reported By */}
                            <div className="min-w-[250px] flex gap-2 items-center">
                              <UserProfile
                                src={report?.reporter?.photo_url}
                                name={report?.reporter?.stage_name}
                                userId={report?.reporter?.id}
                                email={report?.reporter?.email}
                              />
                            </div>

                            {/* Account Status */}
                            <div className='min-w-[130px]'>
                              <h2 className={` w-fit rounded-lg px-2 font-poppins text-sm ${report.status === 1 ? "text-[#0D9947] bg-opacity-20 bg-[#0D9947]" : "text-red-500 bg-opacity-20 bg-red-500"}`}>{report.status === 1 ? "Active" : "Deactive"}</h2>
                            </div>

                            {/* Actions */}
                            <div className="min-w-[65px] flex justify-center gap-4">
                              <button className="bg-[#FDE4EA] dark:bg-[#FF3030] dark:bg-opacity-[6%] rounded-full p-2" onClick={() => handleBlock(report.reported?.stage_name, report?.reported?.id, report?.status)}>
                                <img src={Report} className='block w-4 h-4 dark:hidden' />
                                <img src={Block} className='hidden w-4 h-4 dark:block' />
                              </button>
                            </div>
                          </div>
                        ))}
                      </>) :

                      (<>
                        <div className='flex flex-col justify-center py-32 2xl:py-36 place-items-center'>
                          <img src={NoData} alt="no data" className='w-96' />
                          <h2 className='font-poppins text-[#000000] text-sm font-semibold'>Don't have any data to show</h2>
                        </div>
                      </>)}

                  </>)}




                {/* Pagination and Results Count */}
                {reportList?.length > 0 ?

                  (<>
                    <div className="flex justify-between px-10 py-6 bg-white dark:bg-primary">
                      {/* Results Count */}
                      <div className="relative flex gap-2 place-items-center" ref={dropdownRef}>
                        {/* Dropdown Button */}
                        <div
                          className="border border-[#9C9C9C] dark:border-[#1F1F1F]  bg-[#edeff166] dark:bg-primary rounded-xl flex gap-2 items-center px-3 py-1 cursor-pointer relative"
                          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                        >
                          <p className="text-[#00162e] dark:text-darkText font-poppins">{selectedValue}</p>
                          <button>
                            <img src={Arrow} className="w-4 h-4" />
                          </button>
                        </div>

                        {/* Dropdown Menu - Positioned Above */}
                        {isDropdownOpen && (
                          <div className="absolute left-0 z-50 mb-2 bg-white border dark:text-darkText dark:border-[#1F1F1F] border-gray-300 rounded-lg shadow-lg dark:bg-primary bottom-full w-max">
                            {options.map((option) => (
                              <p
                                key={option}
                                className="px-4 py-2 text-sm cursor-pointer hover:bg-gray-100"
                                onClick={() => handleSelect(option)}>
                                {option}
                              </p>
                            ))}
                          </div>
                        )}

                        {/* Results Text */}
                        <p className="text-[#333333] font-poppins text-sm dark:text-gray-600">
                          Showing <span className="font-semibold text-[#000000] dark:text-darkText text-sm">{pagination?.total}</span> results
                        </p>
                      </div>

                      {/* Pagination Buttons */}

                      <div className="flex items-center">
                        {/* Previous Button */}
                        <button
                          className={`text-[#000000] dark:text-darkText text-sm font-poppins px-3 py-1 rounded-full transition-all duration-200 
        ${pagination?.prev_page === 0 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-200"}`}
                          onClick={() => setActivePage(prev => (prev > 1 ? prev - 1 : prev))}
                          disabled={pagination?.prev_page === 0}>
                          Previous
                        </button>

                        {/* Page Numbers */}
                        {[...Array(lastPage)].map((_, index) => {
                          const page = index + 1;
                          return (
                            <button
                              key={page}
                              className={`text-sm font-poppins px-3 py-1 rounded-full transition-all duration-200 
            ${activePage === page ? "text-white bg-button-gradient" : "text-black dark:text-darkText hover:bg-gray-200"}`}
                              onClick={() => setActivePage(page)}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {/* Next Button */}
                        <button
                          className={`text-[#000000] dark:text-darkText text-sm font-poppins px-3 py-1 rounded-full transition-all duration-200 
        ${pagination?.next_page > lastPage ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-200"}`}
                          onClick={() => setActivePage(prev => (prev < lastPage ? prev + 1 : prev))}
                          disabled={pagination?.next_page > lastPage}
                        >
                          Next
                        </button>
                      </div>

                    </div>
                  </>) :

                  (<></>)}

              </div>
            </div>
          </div>

        </div>
      </div>

      <BlockUser
        open={block}
        handleClose={handleCloseBlock}
        UserID={BlockUserId}
      />
    </>
  );
}

export default ReportList;

